module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_AudioOn_16"],"path":[{"$":{"d":"M9,1V15L3,11H0V5H3Zm7,7a7.78,7.78,0,0,0-2.44-5.65l-1,1.09a6.25,6.25,0,0,1,0,9.12l1,1.09A7.77,7.77,0,0,0,16,8ZM12.88,8a5.72,5.72,0,0,0-1.64-4L10.17,5a4.25,4.25,0,0,1,0,5.95l1.07,1A5.72,5.72,0,0,0,12.88,8Z","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_AudioOn_16.svg
// module id = i4Ir
// module chunks = 1